(function () {
  const defaultTranslations = {
    searchResult: "Suchergebnis",
    searchForProducts: "Produkte suchen",
    selectedFilters: "Ausgewählte Filter",
    clearAll: "Alle löschen",
    noResultFound: "Kein Ergebnis gefunden",
    tryClearingFilters: "Versuche die Filter zu löschen",
    tryWord: "Versuche",
    clearFilters: "die Filter zu löschen",
    orWord: "oder",
    changingYourInput: "ändere deine Eingabe",
    price: "Preis",
    priceRange: "Preisspanne",
    type: "Typ",
    sortedBy: "Sortiert nach",
    relevance: "Relevanz",
    mostPopular: "Beliebteste",
    addToCart: "In den Warenkorb",
    saleable: "Verfügbar",
    outOfStock: "Ausverkauft"
  };

  const tr                      = Object.assign({}, defaultTranslations, window.algoliaThemeTranslations || {});
  const taxMultiplier           = Number(window.algoliaTaxMultiplier || 1.19);
  // Default ON. Set window.algoliaUseCustomGrossConverter = false to disable.
  const useCustomGrossConverter = window.algoliaUseCustomGrossConverter !== false;

  let translateTimer            = null;

  /**
   * Parses a localized money string into a float.
   * Supports both de-DE and en-US style separators.
   *
   * @param {string} text Raw text containing a monetary value
   *
   * @returns {number | null}
   */
  function parseMoneyValue(text) {
    if (!text) {
      return null;
    }

    const raw = String(text).replace(/[^\d,.-]/g, "").trim();

    if (!raw) {
      return null;
    }

    const commaIndex = raw.lastIndexOf(",");
    const dotIndex   = raw.lastIndexOf(".");
    let normalized   = raw;

    // If comma appears later than dot, assume de-DE style: 1.234,56
    if (commaIndex > dotIndex) {
      normalized = raw.replace(/\./g, "").replace(",", ".");
    } else if (dotIndex > commaIndex && commaIndex !== -1) {
      // en-US style with thousand separators and decimal dot: 1,234.56
      normalized = raw.replace(/,/g, "");
    } else if (commaIndex !== -1 && dotIndex === -1) {
      // Simple comma-decimal value: 12,34
      normalized = raw.replace(",", ".");
    }

    const value  = Number(normalized);
    return Number.isFinite(value) ? value : null;
  }

  /**
   * Finds the first money segment in a text (with optional euro prefix/suffix).
   *
   * @param {string} text Raw text
   *
   * @returns {string | null}
   */
  function extractMoneySegment(text) {
    if (!text) {
      return null;
    }

    const match = String(text).match(/(?:€\s*)?-?\d{1,3}(?:[.\s]\d{3})*(?:,\d{2})\s*€?|(?:€\s*)?-?\d{1,3}(?:[,\s]\d{3})*(?:\.\d{2})\s*€?|(?:€\s*)?-?\d+[,.]\d{2}\s*€?/);
    return match ? match[0] : null;
  }

  /**
   * Converts Algolia hit prices from net to gross in-place.
   * Uses a data marker to avoid repeated conversion when Algolia re-renders.
   *
   * @returns {void}
   */
  function convertAlgoliaPricesToGross() {
    // Default ON: we keep this converter active unless explicitly disabled.
    if (!useCustomGrossConverter) {
      return;
    }

    if (!Number.isFinite(taxMultiplier) || taxMultiplier <= 0) {
      return;
    }

    const selectors = [
      ".aa-Panel .aa-ItemContentPrice",
      ".aa-ItemContentPriceCurrent",
      ".aa-ItemContentPrice",
      "p.ais-hit--price > b",
      ".ais-hit--price > b"
    ];

    document.querySelectorAll(selectors.join(", ")).forEach(
      (el) => {
        const originalText   = normalizeText(el.textContent);

        if (!originalText) {
          return;
        }

        // Skip ranges and non-price strings.
        if (/\s[-–]\s/.test(originalText)) {
          return;
        }

        const moneySegment   = extractMoneySegment(originalText);
        if (!moneySegment) {
          return;
        }

        const lastGrossValue = el.getAttribute("data-gross-value");

        // Skip only when this exact rendered money segment was already converted.
        // Algolia can reuse DOM nodes and write fresh net prices into the same element,
        // so a simple boolean marker is too sticky and leaves later values unconverted.
        if (lastGrossValue && moneySegment === lastGrossValue) {
          return;
        }

        const moneyNumeric = moneySegment.replace(/[^\d,.-]/g, "");
        const net          = parseMoneyValue(moneyNumeric);

        if (net === null) {
          return;
        }

        const gross        = Math.round((net * taxMultiplier + Number.EPSILON) * 100) / 100;
        const hasEuro      = /€/.test(originalText);
        const euroPrefix   = /^\s*€/.test(moneySegment);
        const formatted    = gross.toLocaleString(
          "de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        );

        const moneyReplacement = euroPrefix ? `€${formatted}` : (hasEuro ? `${formatted} €` : formatted);
        const nextText         = originalText.replace(moneySegment, moneyReplacement);

        setIfDifferent(el, nextText);
        el.setAttribute("data-gross-fixed", "true");
        el.setAttribute("data-gross-value", moneyReplacement);
      }
    );
  }

  /**
   * Normalizes a text string by collapsing whitespace and trimming it.
   *
   * @param {string | null | undefined} text The input text
   * 
   * @returns {string} Normalized string
   */
  function normalizeText(text) {
    return (text || "").replace(/\s+/g, " ").trim();
  }

  /**
   * Replaces the text content of an element only if it differs.
   *
   * @param {HTMLElement} el       Target element
   * @param {string}      newValue New text value
   */
  function setIfDifferent(el, value) {
    if (el && el.textContent !== value) {
      el.textContent = value;
    }
  }

  /**
   * Translates the Algolia stats line:
   * 
   * Example:
   * "1 - 12 out of 366 results found in 0.001s"
   *
   * @returns {void}
   */
  function setExactText(selector, map) {
    document.querySelectorAll(selector).forEach((el) => {
      const text = normalizeText(el.textContent);
      if (map[text] && text !== map[text]) {
        el.textContent = map[text];
      }
    });
  }

  /**
   * Translates the main search result header.
   *
   * @returns {void}
   */
  function translateStats() {
    document.querySelectorAll(".ais-stats--nb-results, .ais-Stats-text, .ais-stats, [class*='ais-stats']").forEach((el) => {
      const text = normalizeText(el.textContent);
      // Matches EN and DE variants, for example:
      // "1 - 12 out of 366 results found in 0.001s"
      // "1 - 12 of 366 results found in 0.001s"
      // "1 - 12 von 366 Treffern gefunden in 0.001s"
      const match         = text.match(/^(\d+)\s*[-–]\s*(\d+)\s+(?:out of|of|von)\s+([\d.,]+)\s+(?:results?|Treffern?)(?:\s+(?:found|gefunden))?\s*(?:in\s+(.+))?$/i);
      const noResultMatch = text.match(/^No results? found(?:\s+in\s+(.+))?$/i);

      if (match) {
        const parseNumber = (value) => {
          const digits = String(value || "").replace(/\D/g, "");
          return digits ? parseInt(digits, 10) : NaN;
        };

        let from      = parseInt(match[1], 10);
        let to        = parseInt(match[2], 10);
        const total   = match[3];
        const totalNo = parseNumber(total);
        const time    = match[4];

        // Algolia can occasionally render stale 1-x ranges while the URL already
        // points to a later page. Recompute the visible range from ?page= when possible.
        const pageParam       = parseInt(new URLSearchParams(window.location.search).get("page"), 10);
        const parsedPerPage   = Number.isFinite(from) && Number.isFinite(to) && to >= from ? (to - from + 1) : 0;
        const visibleHits     = document.querySelectorAll(".ais-Hits-item, .ais-InfiniteHits-item").length;
        const fallbackPerPage = Number(window.algoliaResultsPerPage || 12);

        // Prefer a stable page size on later pages because Algolia can briefly
        // render stale partial ranges (e.g. 1-4) before final hydration.
        let perPage = parsedPerPage;

        if (Number.isFinite(pageParam) && pageParam > 1) {
          perPage = Math.max(
            parsedPerPage || 0,
            Number.isFinite(visibleHits) ? visibleHits : 0,
            Number.isFinite(fallbackPerPage) ? fallbackPerPage : 0
          );
        }

        if (Number.isFinite(pageParam) && pageParam > 1 && Number.isFinite(totalNo) && totalNo > 0 && perPage > 0) {
          const computedFrom = (pageParam - 1) * perPage + 1;

          if (computedFrom <= totalNo) {
            from = computedFrom;
            to   = Math.min(computedFrom + perPage - 1, totalNo);
          }
        }

        const fromTo = `${from} - ${to}`;
        const suffix = time ? ` in ${time}` : "";
        setIfDifferent(el, `${fromTo} von ${total} Treffern gefunden${suffix}`);
      } else if (noResultMatch) {
        const time   = noResultMatch[1];
        const suffix = time ? ` in ${time}` : "";
        setIfDifferent(el, `${tr.noResultFound}${suffix}`);
      }
    });
  }

  /**
   * Translates facet (filter) headers like:
   * Price, Price range, Type
   *
   * @returns {void}
   */
  function translateFacetHeaders() {
    setExactText(".ais-Panel-header", {
      "Price": tr.price,
      "Price range": tr.priceRange,
      "Type": tr.type
    });
  }

  /**
   * Translates "Add to cart" buttons in search results.
   *
   * @returns {void}
   */
  function translateHeader() {
    setExactText("h1.ais-h2, h2.ais-h2, .ais-h2", {
      "Search result": tr.searchResult
    });
  }

  /**
   * Translates facet values (e.g. "Saleable").
   *
   * @returns {void}
   */
  function translateButtons() {
    setExactText(".ais-Hits-item button, .ais-InfiniteHits-item button, button", {
      "Add to cart": tr.addToCart,
      "Out of stock": tr.outOfStock,
      "OUT OF STOCK": tr.outOfStock
    });
  }

  /**
   * Translates Algolia search box placeholders.
   *
   * @returns {void}
   */
  function translateSearchPlaceholders() {
    document.querySelectorAll(".ais-SearchBox-input, .aa-Input, input[type='search'], input[placeholder]").forEach((el) => {
      const current = normalizeText(el.getAttribute("placeholder"));

      if (current.toLowerCase().includes("search for products")) {
        el.setAttribute("placeholder", tr.searchForProducts);
        el.setAttribute("aria-label", tr.searchForProducts);

        if (el.getAttribute("title")) {
          el.setAttribute("title", tr.searchForProducts);
        }
      }
    });
  }

  /**
   * Translates the "Sorted by" label which exists as a raw text node.
   *
   * Example DOM:
   * <div class="ais-sort">
   *   "Sorted by"
   *   <span>...</span>
   * </div>
   *
   * @returns {void}
   */
  function translateFacetValues() {
    setExactText(".ais-RefinementList-labelText, .ais-RefinementList-item label span", {
      "Saleable": tr.saleable
    });
  }

  /**
   * Translates sort options such as:
   * Relevance, Most popular
   *
   * @returns {void}
   */
  function translateSortLabels() {
    setExactText(
      ".ais-SortBy-label, .ais-sort-by-label, .ais-SortBy-select option, .ais-sort-by-selector option, .ais-SortBy-option",
      {
        "Selected filters": tr.selectedFilters,
        "SELECTED FILTERS": tr.selectedFilters,
        "Clear all": tr.clearAll,
        "Sorted by": tr.sortedBy,
        "Relevance": tr.relevance,
        "Most popular": tr.mostPopular
      }
    );

    document.querySelectorAll(
      ".ais-SortBy, .ais-sort-by, .ais-SortBy-select, .ais-sort-by-selector, [class*='sort-by'], [class*='SortBy']"
    ).forEach((el) => {
      const text = normalizeText(el.textContent);

      if (text === "Sorted by") {
        setIfDifferent(el, tr.sortedBy);
      }
    });
  }

  /**
   * Main translation orchestrator.
   * Ensures all Algolia UI elements are translated.
   *
   * Prevents re-entrant execution using a lock.
   *
   * @returns {void}
   */
  function translateSpecificTextNodes() {
    document.querySelectorAll("span, label, small, option, div, p, h1, h2, h3, h4, h5, h6, li, a, button").forEach((el) => {
      if (el.children.length > 0) return;

      const text = normalizeText(el.textContent);

      const map = {
        "No result found": tr.noResultFound,
        "No results found": tr.noResultFound,
        "Try clearing the filters": tr.tryClearingFilters,
        "Try clearing the filters or": `${tr.tryClearingFilters} ${tr.orWord}`,
        "changing your input": tr.changingYourInput,
        "Selected filters": tr.selectedFilters,
        "SELECTED FILTERS": tr.selectedFilters,
        "Clear all": tr.clearAll,
        "Price": tr.price,
        "Price range": tr.priceRange,
        "Type": tr.type,
        "Search result": tr.searchResult,
        "Sorted by": tr.sortedBy,
        "Relevance": tr.relevance,
        "Most popular": tr.mostPopular,
        "Add to cart": tr.addToCart,
        "Saleable": tr.saleable,
        "Out of stock": tr.outOfStock,
        "OUT OF STOCK": tr.outOfStock
      };

      if (map[text]) {
        setIfDifferent(el, map[text]);
      }
    });
  }

  /**
   * Translates link/button labels that are rendered as separate anchor nodes
   * in Algolia no-results templates.
   *
   * @returns {void}
   */
  function translateNoResultLinks() {
    setExactText("a, button", {
      "clearing the filters": tr.clearFilters,
      "Clearing the filters": tr.clearFilters,
      "changing your input": tr.changingYourInput,
      "Change your input": tr.changingYourInput
    });
  }

  /**
   * Translates split no-result sentence fragments (e.g. "Try" + link + "or").
   * Scoped to no-result containers to avoid changing unrelated content.
   *
   * @returns {void}
   */
  function translateNoResultFragments() {
    document.querySelectorAll(".ais-NoResults, .ais-no-results, [class*='NoResults'], [class*='no-results'], .ais-hit-empty, [class*='hit-empty']").forEach((root) => {
      root.querySelectorAll("a, button").forEach((el) => {
        const text = normalizeText(el.textContent);

        if (/^clearing\s+the\s+filters$/i.test(text)) {
          setIfDifferent(el, tr.clearFilters);
        }

        if (/^changing\s+your\s+input\.?$/i.test(text)) {
          setIfDifferent(el, tr.changingYourInput);
        }
      });

      root.querySelectorAll("span, p, div, small, li, strong, em").forEach((el) => {
        if (el.children.length > 0) {
          return;
        }

        const text = normalizeText(el.textContent);

        if (/^try$/i.test(text)) {
          setIfDifferent(el, `${tr.tryWord} `);
        } else if (/^or$/i.test(text)) {
          setIfDifferent(el, tr.orWord);
        }
      });

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();

      while (node) {
        const original = node.nodeValue || "";
        const trimmed = normalizeText(original);
        let next = original;

        if (/^try$/i.test(trimmed)) {
          next = `${tr.tryWord} `;
        } else if (/^or$/i.test(trimmed)) {
          next = ` ${tr.orWord} `;
        }

        if (next !== original) {
          node.nodeValue = next;
        }

        node = walker.nextNode();
      }
    });
  }

  /**
   * Translates no-result fragments when the sentence is split into text nodes
   * with a separate anchor element for the last part.
   *
   * @returns {void}
   */
  function translateNoResultTextNodes() {
    document.querySelectorAll(".ais-Hits, .ais-InfiniteHits, .ais-NoResults, .ais-Panel, .ais-root").forEach((el) => {
      el.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE || !node.nodeValue) {
          return;
        }

        let value = node.nodeValue;

        value = value.replace(/No\s+result\s+found/gi, tr.noResultFound);
        value = value.replace(/Try\s+clearing\s+the\s+filters\s+or/gi, `${tr.tryClearingFilters} ${tr.orWord}`);

        if (value !== node.nodeValue) {
          node.nodeValue = value;
        }
      });
    });
  }

  /**
   * Replaces known English no-results phrases directly in text nodes.
   * This catches fragmented templates where part of a sentence is rendered
   * outside the elements targeted by selector-based translations.
   *
   * @returns {void}
   */
  function translateNoResultPhrasesGlobally() {
    const root = document.querySelector("main") || document.body;

    if (!root) {
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      const original = node.nodeValue || "";
      let next = original;

      next = next.replace(/No\s+result\s+found\s+in\s*([0-9.]+s)/gi, `${tr.noResultFound} in $1`);
      next = next.replace(/No\s+results\s+found\s+in\s*([0-9.]+s)/gi, `${tr.noResultFound} in $1`);
      next = next.replace(/No\s+result\s+found/gi, tr.noResultFound);
      next = next.replace(/No\s+results\s+found/gi, tr.noResultFound);
      next = next.replace(/clearing\s+the\s+filters/gi, tr.clearFilters);
      next = next.replace(/changing\s+your\s+input/gi, tr.changingYourInput);

      if (next !== original) {
        node.nodeValue = next;
      }

      node = walker.nextNode();
    }
  }

  /**
   * Translates the "Sorted by" label which exists as a raw text node.
   *
   * Example DOM:
   * <div class="ais-sort">
   *   "Sorted by"
   *   <span>...</span>
   * </div>
   *
   * @returns {void}
   */
  function translateSortedBy() {
    document.querySelectorAll(".ais-sort").forEach((el) => {
      el.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          if (node.nodeValue.includes("Sorted by")) {
            node.nodeValue = node.nodeValue.replace("Sorted by", tr.sortedBy);
          }
        }
      });
    });
  }

  /**
   * Translates the Algolia Autocomplete panel (aa-* elements):
   * section headers, no-results messages, "see all" links, and
   * recent-search labels that the Autocomplete JS renders in English.
   *
   * @returns {void}
   */
  function translateAutocompletePanel() {
    // Source / section headers inside the autocomplete dropdown
    setExactText(
      ".aa-SourceHeader, .aa-SourceHeaderTitle", {
        "Products":              tr.searchForProducts,
        "Suggestions":           tr.suggestions    || "Vorschläge",
        "Pages":                 tr.pages          || "Seiten",
        "Blog posts":            tr.blogPosts       || "Blog Artikel",
        "Collections":           tr.collections    || "Kategorien",
        "Recent searches":       tr.recentSearches || "Letzte Suchen",
        "No recent searches":    tr.noRecentSearches || "Keine letzten Suchen"
      }
    );

    // "See all results for …" / "See all products for …" links
    document.querySelectorAll(".aa-SourceFooterLink, .aa-Panel a[href*='/search']").forEach((el) => {
      const text        = normalizeText(el.textContent);
      const seeAllMatch = text.match(/^See all (products|results) for\s+"?(.+?)"?\s*$/i);

      if (seeAllMatch) {
        const term = seeAllMatch[2];
        setIfDifferent(el, `Alle Ergebnisse für "${term}" anzeigen`);
      }
    });

    // No-results message in the autocomplete panel
    setExactText(
      ".aa-NoResults, .aa-NoResultsMessage, [class*='aa-NoResult']", {
        "No results":                tr.noResultFound,
        "No results found":          tr.noResultFound,
        "No result found":           tr.noResultFound,
        "No products found":         tr.noResultFound
      }
    );

    // Clear / reset buttons inside the autocomplete
    setExactText(
      ".aa-ClearButton, [class*='aa-Clear']", {
        "Clear":       tr.clearAll,
        "Clear all":   tr.clearAll
      }
    );
  }

  /**
   * Translates sort options such as:
   * Relevance, Most popular
   *
   * @returns {void}
   */
  function translateSortOptions() {
    document.querySelectorAll(
      ".ais-sort-orders-container span, .ais-SortBy-option, .ais-SortBy-select option"
    ).forEach((el) => {
      const text = normalizeText(el.textContent);

      if (text === "Relevance") setIfDifferent(el, tr.relevance);
      if (text === "Most popular") setIfDifferent(el, tr.mostPopular);
    });
  }


  /**
   * Main translation orchestrator.
   * Ensures all Algolia UI elements are translated.
   *
   * Prevents re-entrant execution using a lock.
   *
   * @returns {void}
   */
  function translateAlgolia() {
    translateHeader();
    translateStats();
    translateFacetHeaders();
    translateButtons();
    translateSearchPlaceholders();
    translateFacetValues();
    translateSortLabels();
    translateSpecificTextNodes();
    translateNoResultTextNodes();
    translateNoResultFragments();
    translateNoResultPhrasesGlobally();
    translateNoResultLinks();
    translateSortOptions();
    translateSortedBy();
    translateAutocompletePanel();
    convertAlgoliaPricesToGross();
  }

  /**
   * Schedules a translateAlgolia() run after a short debounce.
   * Replaces the old isRunning lock so that mutations which arrive
   * while a translation pass is in progress still trigger a follow-up
   * pass once Algolia finishes its render burst.
   *
   * @returns {void}
   */
  function scheduleTranslate() {
    if (translateTimer) clearTimeout(translateTimer);
    translateTimer = setTimeout(() => {
      translateTimer = null;
      translateAlgolia();
    }, 50);
  }

  /**
   * Initializes translation logic and attaches a MutationObserver
   * to handle dynamically rendered Algolia content.
   *
   * @returns {void}
   */
  function initAlgoliaTranslations() {
    translateAlgolia();
    setTimeout(translateAlgolia, 300);
    setTimeout(translateAlgolia, 1000);
    setTimeout(translateAlgolia, 2500);

    // Always observe document.body so the autocomplete portal (which Algolia
    // renders outside <main>) is also covered.
    const observer = new MutationObserver(scheduleTranslate);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAlgoliaTranslations);
  } else {
    initAlgoliaTranslations();
  }
})();

// Algolia: Listenansicht als Standard aktivieren
(function () {
  let attempts = 0;

  const timer = setInterval(function () {
    const listButton = document.querySelector('.ais-change-display-list');

    if (listButton) {
      if (!listButton.classList.contains('ais-change-display-selected')) {
        listButton.click();
      }
      clearInterval(timer);
    } else if (++attempts >= 30) {
      clearInterval(timer);
    }
  }, 300);
})();